import { defaultCtx } from "~/lib/AjaxCtx"
import { css } from "~/lib/aphrodite"
import store from "~/store"

export default {
    install(app) {
        app.directive("external-links", el => {
            const as = Array.from(el.querySelectorAll("a"))
            for (const a of as) {
                a.setAttribute("target", "_blank")
                a.setAttribute("ref", "nofollow noopener")
            }
        })

        app.config.globalProperties.$css = css
        Object.defineProperty(app.config.globalProperties, "$theme", {
            get() {
                return store.getters["theme/styles"]
            },
        })

        /**
         * This function returns the class needed for the background color
         * using Aphrodite classes if needed
         * @param color
         * @returns String
         */
        app.config.globalProperties.$bg = function $bg(color) {
            if (!color) return ""
            switch (color) {
                case "primary":
                    return this.$css(this.$theme.bgPrimary)
                case "negative":
                    return this.$css(this.$theme.bgNegative)
                case "danger":
                case "success":
                case "warning":
                case "gray-dark":
                case "gray-light":
                case "gray-medium":
                case "white":
                case "black":
                case "transparent":
                    return `bg-${color}`
                default:
                    throw new Error(`Color ${color} is not defined`)
            }
        }

        /**
         * This function returns the class needed for the text color
         * using Aphrodite classes if needed
         * @param color
         * @returns String
         */
        app.config.globalProperties.$text = function $text(color) {
            if (!color) return ""
            switch (color) {
                case "primary":
                    return this.$css(this.$theme.textPrimary)
                case "negative":
                    return this.$css(this.$theme.textNegative)
                case "danger":
                case "success":
                case "warning":
                case "gray-dark":
                case "gray-light":
                case "gray-medium":
                case "white":
                case "black":
                case "transparent":
                    return `text-${color}`
                default:
                    throw new Error(`Color ${color} is not defined`)
            }
        }

        app.config.globalProperties.$http = defaultCtx

        app.config.globalProperties.$assign = window.location.assign.bind(
            window.location
        )
    },
}
